import layout from './layout';
import naive from './naiveui';
import utils from './utils';
import commonRouter from './router/common';
import catalogueRouter from './router/catalogue';
import detailRouter from './router/detail';
import exportRouter from './router/export';
import homeRouter from './router/home';
import promoInfoRouter from './router/promoInfo';
import settingRouter from './router/setting';
import simpleIndexRouter from './router/simpleIndex';

import table from './components/table';
import form from './components/form';
import atFavoriteTable from './components/atFavoriteTable';
import atModals from './components/atModals';
import favoriteModal from './components/favoriteModal';
import uploadFileModal from './components/uploadFileModal';
import accountCard from './components/accountCard';
import MonitoredModal from './components/monitoredModal';
import model from './components/model';

import login from './views/login';
import home from './views/home';
import simpleIndex from './views/simpleIndex';
import jescard from './views/jescard';
import topSimple from './views/topSimple';
import exportCondition from './views/exportCondition';
import promoInfo from './views/promoInfo';
import detail from './views/detail';
import exportSku from './views/exportSku';
import exportHistory from './views/exportHistory';
import goodsDetail from './views/goodsDetail';
import category from './views/category';
import setting from './views/setting';

export default {
  layout,
  utils,
  views: {
    login,
    home,
    simpleIndex,
    jescard,
    topSimple,
    exportCondition,
    exportSku,
    exportHistory,
    promoInfo,
    detail,
    goodsDetail,
    category,
    setting,
  },
  components: {
    table,
    form,
    atFavoriteTable,
    atModals,
    favoriteModal,
    uploadFileModal,
    accountCard,
    MonitoredModal,
    model,
  },
  router: {
    common: commonRouter,
    catalogue: catalogueRouter,
    detail: detailRouter,
    export: exportRouter,
    home: homeRouter,
    promoInfo: promoInfoRouter,
    setting: settingRouter,
    simpleIndex: simpleIndexRouter,
  },
};
export { naive };
